import { combineReducers } from 'redux';
import userReducer from './userReducer';
import filterReducer from './filterReducer';
import ordersReducer from './ordersReducer';
import optionChainReducer from './optionChainReducer';
import basketReducer from './basketReducer';
import socketJwtReducer from './socketJwtReducer';
import tradeFeedSourceReducer from './tradeFeedSourceReducer';
import sockSourceReducer from './sockSourceReducer';
import windowScreenReducer from './windowScreenReducer';
import marginReducer from './marginReducer';
import positionTokenReducer from './positionTokenReducer';
import placeorderReducer from './placeorderReducer';
import configReducer from './configReducer';
import packageReducer from './packageReducer';
import brokersReducer from './brokersReducer';


const reducer = combineReducers({
    user: userReducer,
    filter:filterReducer,
    orders:ordersReducer,
    optionChaininstruments:optionChainReducer,
    basket:basketReducer,
    socketJwt:socketJwtReducer,
    tradeFeedSource: tradeFeedSourceReducer,
    sockSource: sockSourceReducer,
    windowScreen :windowScreenReducer,
    margin:marginReducer,
    positionToken:positionTokenReducer,
    isOrder:placeorderReducer,
    instrumentConfig:configReducer,
    packages:packageReducer,
    brokers: brokersReducer
});

export default reducer;